import classNames from 'classnames'
import { AnimatePresence, motion } from 'framer-motion'
import { PropsWithChildren, useMemo } from 'react'

import { useWindowDimensions } from '@apps-common/hooks/useWindowDimensions'
import { useMenuStore } from '@apps-common/stores'
import { IonHeader } from '@ionic/react'

export const HEADER_DEFAULT_X_PADDING_STYLES = 'px-[1rem] lg:px-[1.4rem] xl:px-[2rem] max-w-[1650px] pb-[5px]'
export const HEADER_DEFAULT_PADDING_STYLES = 'px-[1rem] lg:px-[1.4rem] xl:px-[2rem] max-w-[1650px] pb-[5px]'

interface ItemProps {
  classes?: string
}

export const Header = ({ classes, children }: PropsWithChildren<ItemProps>) => {
  const { open, setOpen } = useMenuStore()
  const { width, isMobile, isTablet } = useWindowDimensions()

  const closedWidth = isMobile || isTablet ? '0px' : '80px'

  const mlValue = useMemo(() => (open ? '230px' : closedWidth), [open, closedWidth])

  if (!width) return null

  return (
    <IonHeader translucent className='bg-transparent'>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={false}
            animate={{
              marginLeft: mlValue,
              opacity: open ? 1 : 0,
              transition: { type: 'tween' }
            }}
            className={classNames('fixed top-0 left-0 bg-bg/5 w-full h-[100vh] z-[99] ')}
            onClick={() => {
              if (open) {
                setOpen(false)
              }
            }}
          />
        )}
      </AnimatePresence>
      <motion.div
        initial={false}
        animate={{
          marginLeft: mlValue,
          opacity: open ? 0.5 : 1,
          transition: { type: 'tween' }
        }}
        className={classNames(
          classes,
          HEADER_DEFAULT_PADDING_STYLES,
          'safe-area-top bg-gradient-to-b from-bg from-10% to-bg/60 to-100% backdrop-blur-sm fixed z-[5]',
          (isMobile || isTablet) && 'w-full',
          !isMobile && !isTablet && 'w-[calc(100%-100px)]'
          // isMobile && !isTablet && 'shadow'
        )}
      >
        {children}
      </motion.div>
    </IonHeader>
  )
}
